module.exports = __webpack_public_path__ + "assets/img/yilang.794d3ce6.png";